import { type JSX } from "react";

interface TileFrameProps {
	children: JSX.Element;
	row: number;
	column: number;
	size: number;
}
export default function TileFrame({
	children,
	row,
	column,
	size,
}: TileFrameProps) {
	return (
		<svg
			role="cell"
			x={column * size}
			y={row * size}
			width={size}
			height={size}
		>
			{children}
		</svg>
	);
}
